export default {
  computed: {
    namedStatuses() {
      return {
        accept: 3,
        refuse: 4
      };
    }
  }
};
